import React from 'react'
import { useParams } from 'react-router-dom'
import _ from 'underscore'

import NotFound from 'pages/NotFound'
import DeviceMetricForm from 'pages/shared/DeviceMetricForm'

import useDeviceMetrics from 'hooks/useDeviceMetrics'
import useTrends from 'hooks/useTrends'
import { useStoreContext } from 'hooks/StoreContext'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'

const EditDeviceMetric = () => {
  useDeviceMetrics()
  useTrends()

  const { deviceMetrics, areDeviceMetricsLoaded, areTrendsLoaded } = useStoreContext()

  const { id } = useParams()

  if (!(areDeviceMetricsLoaded && areTrendsLoaded)) {
    return <LoadingSinglePanePage />
  }

  const metric = _.find(deviceMetrics, (metric) => metric.id === id)

  return (
    <SinglePanePage>
      {
         metric ? <DeviceMetricForm
         title="Edit Device Metric"
         validatedSaveType="update"
         deviceMetric={metric}
                  /> : <NotFound />
      }

    </SinglePanePage>
  )
}

export default EditDeviceMetric
